import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'reactstrap';
import { colors } from 'shared/defaultTheme';
import { setEmailToContactsOnPublish } from 'redux/actions/documentActions';
import { useSelector, useDispatch } from 'react-redux';
import { Switch } from 'shared/components/form/Inputs';

const SwitchEmailToContacts = ({ selectedContacts }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { emailToContactsOnPublish } = useSelector((state) => state.document);

  useEffect(() => {
    return () => {
      dispatch(setEmailToContactsOnPublish(true));
    };
  }, []);

  if (selectedContacts === 0) return null;

  return (
    <Container className="p-0">
      <Row>
        <Col xs={12}>
          <div className="mb-3">
            <div className="d-flex justify-content-between">
              <span className="mr-2">
                {`${t('client_contact_notifications')} (${selectedContacts})`}
              </span>
              <Switch
                id="switchSendContactsEmail"
                onChange={() => dispatch(setEmailToContactsOnPublish(!emailToContactsOnPublish))}
                value={!emailToContactsOnPublish}
                color={emailToContactsOnPublish ? colors.pastelGreen : colors.venetianRed}
              />
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

SwitchEmailToContacts.propTypes = {
  selectedContacts: PropTypes.number.isRequired,
};

export default SwitchEmailToContacts;
